import * as React from "react";
import { styled } from "@mui/material/styles";
import {
  Table, TableBody, TableContainer, TableHead, TableRow, Paper, Container, IconButton
} from "@mui/material";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import { Download, Link as LinkIcon } from "@mui/icons-material";

import { useState, useEffect } from "react";

import Config from "../config.json"; // Pastikan file ini ada
import { dateToStringDate } from "../Helpers"; // Pastikan fungsi ini ada

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    backgroundColor: theme.palette.primary.light,
    color: theme.palette.common.white,
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  "&:nth-of-type(odd)": {
    backgroundColor: theme.palette.action.hover,
  },
  "&:last-child td, &:last-child th": {
    border: 0,
  },
}));

function Generalisasi() {
  // State untuk bagian Events
  const url_list = Config.api_domain + "/generalisasi/active/";
  const [list, setList] = useState([]);
  const [search, setSearch] = useState("");
  const [entriesPerPage, setEntriesPerPage] = useState(5);
  const [page, setPage] = useState(0);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await fetch(url_list, {
          method: "GET",
          headers: { "Content-Type": "application/json" },
        });
        if (!res.ok) throw new Error("Server error");

        const data = await res.json();
        setList(data.data || []);
      } catch (error) {
        console.error("Fetch error:", error.message);
      }
    };

    fetchData();
  }, [url_list]);

  const filteredList = list.filter(item =>
    item.title.toLowerCase().includes(search.toLowerCase())
  );

  const paginatedList = filteredList.slice(
    page * entriesPerPage,
    (page + 1) * entriesPerPage
  );

  function getRows() {
    if (typeof list !== "undefined" && list !== null && list.length > 0) {
      return list.map((row, index) => {
        let dateISO = new Date(row.time_uploaded);
        let formatted_datetime = dateToStringDate(dateISO);
        return (
          <StyledTableRow key={row.public_id}>
            <StyledTableCell>{index + 1}</StyledTableCell>
            <StyledTableCell>{row.title}</StyledTableCell>
            <StyledTableCell>{formatted_datetime}</StyledTableCell>
            <StyledTableCell>
              <IconButton
                aria-label="download"
                component="a"
                href={Config.api_domain + "/generalisasi/download/" + row.public_id}
                download
              >
                <Download />
              </IconButton>
            </StyledTableCell>
          </StyledTableRow>
        );
      });
    } else {
      return (
        <StyledTableRow key="no-data">
          <StyledTableCell colSpan={4} align="center">
            No Data Found
          </StyledTableCell>
        </StyledTableRow>
      );
    }
  }

  return (
    <div style={{ padding: "1em 2em 3em 2em" }}>
      <Container>

        <h2>Generalisasi</h2>

        <h3>Project Description</h3>
        <p style={{ textAlign: "justify" }}>
          Pemerintah Republik Indonesia menerima pinjaman dari Bank Dunia melalui Integrated Land Administration and Spatial Planning Project (ILASPP) IBRD Loan No.: 9732-ID. Badan Informasi Geospasial (BIG) melalui Satuan Kerja Sekretariat Utama, Direktorat Pemetaan Rupabumi Wilayah Darat bermaksud menggunakan sebagian pendanaan tersebut untuk membiayai Pekerjaan Produksi Peta Dasar Wilayah Sulawesi Skala 1:25.000, 1:50.000, 1:250.000, 1:500.000, dan 1:1.000.000 melalui Generalisasi Peta Dasar 1:5.000. 
Maksud dan tujuan dari pekerjaan ini yaitu:
<br></br><br></br>a.Penyediaan peta dasar seamless wilayah Sulawesi berskala besar (1:5.000); dan
<br></br><br></br>b.Pembuatan peta dasar skala menengah (1:25.000 dan 1:50.000) serta peta dasar skala kecil (1:250.000; 1:500.000; dan 1:1.000.000) di wilayah Sulawesi melalui proses generalisasi dari peta dasar skala besar (1:5.000).
<br></br><br></br>Lokasi atau Area of ​​Interest (AOI) pekerjaan adalah wilayah Sulawesi seluas kurang lebih 186.221 km².
        </p>

        {/* Unduh Section */}
        <h3>Announcement</h3>
        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 500 }} aria-label="customized table">
            <TableHead>
              <TableRow>
                <StyledTableCell>No</StyledTableCell>
                <StyledTableCell>Announcement</StyledTableCell>
                <StyledTableCell>Publication Date</StyledTableCell>
                <StyledTableCell>Download</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {getRows()}
            </TableBody>
          </Table>
        </TableContainer>

        <h3>Procurement Timeline</h3>
         <TableContainer component={Paper} sx={{ mb: 6 }}>
  <Table sx={{ minWidth: 800 }} aria-label="timeline table">
    <TableHead>
      <TableRow>
        <StyledTableCell>No.</StyledTableCell>
        <StyledTableCell>Activity</StyledTableCell>
        <StyledTableCell>Start Date</StyledTableCell>
        <StyledTableCell>End Date</StyledTableCell>
      </TableRow>
    </TableHead>
    <TableBody>
      <StyledTableRow>
        <StyledTableCell>1</StyledTableCell>
        <StyledTableCell>Pengumuman RFQ pada website ILASP</StyledTableCell>
        <StyledTableCell>25 September 2025</StyledTableCell>
        <StyledTableCell>8 Oktober 2025</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>2</StyledTableCell>
        <StyledTableCell>Pemberian Penjelasan</StyledTableCell>
        <StyledTableCell>29 September 2025, 09.00 WIB (GMT +7)</StyledTableCell>
        <StyledTableCell>30 September 2025, 12.00 WIB (GMT+7)</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>3</StyledTableCell>
        <StyledTableCell>Pemasukan Dokumen Penawaran</StyledTableCell>
        <StyledTableCell>25 September 2025, 09.00 WIB (GMT +7)</StyledTableCell>
        <StyledTableCell>8 Oktober 2025, 12.00 WIB (GMT+7)</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>4</StyledTableCell>
        <StyledTableCell>Evaluasi Dokumen Penawaran</StyledTableCell>
        <StyledTableCell>8 Oktober 2025, 13.00 WIB (GMT+7)</StyledTableCell>
        <StyledTableCell>14 Oktober 2025, 15.00 WIB (GMT+7) (UPDATED)</StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>5</StyledTableCell>
        <StyledTableCell>Notification of Intention to Award</StyledTableCell>
        <StyledTableCell>14 Oktober 2025, 15.01 WIB (GMT+7) (UPDATED)</StyledTableCell>
        <StyledTableCell>14 Oktober 2025, 23.59 WIB (GMT+7) (UPDATED)</StyledTableCell>
        <StyledTableCell></StyledTableCell>
      </StyledTableRow>

      <StyledTableRow>
        <StyledTableCell>6</StyledTableCell>
        <StyledTableCell>Award of Contract and Publication of Contract Award </StyledTableCell>
        <StyledTableCell>15 Oktober 2025, 00.00 WIB (GMT+7) (UPDATED)</StyledTableCell>
        <StyledTableCell>22 Oktober 2025, 23.59 WIB (GMT+7) (UPDATED)</StyledTableCell>
      </StyledTableRow>
    </TableBody>
  </Table>
</TableContainer>

{/* <p>The package will be processed through SPSE ICB at the link: <a
    href="mailto: https://spseicb.lkpp.go.id/spseicb/"
    style={{ color: "#1976d2", textDecoration: "underline" }}
  > https://spseicb.lkpp.go.id/spseicb/</a></p>  */}
      </Container>
    </div>
  );
}

export default Generalisasi;
